import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/services-bg.jpg")